<script lang="ts">
  import type { ComponentProps } from "svelte"
  import { IlluminationCompass, IlluminationCompassBack, fade } from "@/libs/ui"

  type Props = ComponentProps<typeof IlluminationCompass | typeof IlluminationCompassBack>

  let {
    azimuth,
    thresholds,
    facing = "front",
  }: {
    azimuth: Props["value"]
    thresholds: Props["thresholds"]
    facing?: "front" | "back"
  } = $props()

  let Component = $derived(facing === "front" ? IlluminationCompass : IlluminationCompassBack)
</script>

<div class:indicator-back={facing === "back"}>
  <Component value={azimuth} {thresholds} transition={fade} />
</div>

<style lang="postcss">
  * {
    @apply mt-4 flex w-full flex-col items-center justify-start px-7;
  }

  :global([data-ui-scale="xs"]) *,
  :global([data-ui-scale="sm"]) * {
    @apply mt-3 px-4;
  }

  :global([data-ui-scale="xs"]) * {
    @apply mt-1 px-8;
  }

  .indicator-back {
    @apply -mt-[3.375rem];
  }

  :global([data-ui-scale="xs"]) .indicator-back,
  :global([data-ui-scale="sm"]) .indicator-back {
    @apply -mt-[2.625rem];
  }

  :global([data-ui-scale="xs"]) .indicator-back {
    @apply -mt-[1.75rem] px-8;
  }
</style>
